var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-main"},[_c('h2',[_vm._v(_vm._s(_vm.$t('session.add')))]),_c('session',{on:{"submit":function($event){return _vm.update($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }